import React, { useState, useEffect } from "react";
import DataTable from "@/common/elements/DataTable";
import { StyledFlex, StyledSectionHeading, StyledSubTableContainer } from "@/common/styles";
import { getRefListNameByID } from "@/util/common_function";

const JailIncidentIReviewHearings = ({ data }) => {
  const [tableData, setTableData] = useState({
    headers: [
      { key: "id", text: "ID" },
      { key: "dueDate", text: "Due Date" },
      { key: "dueTime", text: "Due Time" },
      { key: "actualDate", text: "Actual Date" },
      { key: "actualTime", text: "Actual Time" },
      { key: "supervisor", text: "Supervisor" },
      { key: "jaillncidentsResults", text: "JaillncidentsResults" },
      { key: "appeal", text: "Appeal" },
      { key: "comments", text: "Comments" },
    ],
    rows: []
  });

  useEffect(() => {
    if (data && data.jailIncidentsInvolvedInmateReviewHearings) {
      const rows = data.jailIncidentsInvolvedInmateReviewHearings.map((row, index) => ({
        id: row.jailIncidentsInvolvedInmateReviewHearingID || index + 1,
        dueDate: row.dueDate,
        dueTime: row.dueTime,
        actualDate: row.actualDate,
        actualTime: row.actualTime,
        supervisor: getRefListNameByID("", row.supervisor_StaffID, true),
        jaillncidentsResults: row.jailIncidentsResults,
        appeal: row.appeal ? "Yes" : "No",
        comments: row.comments,
      }));
      setTableData(prev => ({ ...prev, rows }));
    }
  }, [data]);

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Review Hearings</span>
      </StyledSectionHeading>
      
      <StyledSubTableContainer>
        <StyledFlex align="center" justify="space-between">
          <h2>List of Jail Incidents Review Hearings</h2>
        </StyledFlex>

        <DataTable headers={tableData.headers} data={tableData.rows} />
      </StyledSubTableContainer>
    </>
  );
};

export default JailIncidentIReviewHearings;
